import React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import dynamic from 'next/dynamic'
import SignInTable from './SignInTable'
import Spacer from '~/components/Spacer'
import ContinueWithButtons from '~/components/auth/ContinueWithButtons'

const LoginModal = dynamic(() => import("~/components/auth/LoginModal"))

const InputContainer = styled.div`
  ${props =>
    props.isMobile
      ? `
    box-shadow: none;
    padding: 0rem;
    background: none;
  `
      : `
    background: white;
    box-shadow: 0 9px 24px 0 rgba(35,41,48,0.15);
    border-radius: 4px;
    padding: 2rem;
  `}
  margin: 2rem 0 2rem 0;
`

const Text = styled.span`
  font-size: 1.125em;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
`

const Or = styled.span`
  color: ${props => props.theme.colors.text.label};
  padding: 0 7px;
`

const SignIn = styled.a.attrs({ href: '#' })`
  margin: 0;
  color: ${props => props.theme.colors.primary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const opener = ({ onClick }) => {
  return (
    <SignIn onClick={onClick}>Sign In</SignIn>
  )
}

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  isLoggedIn: all.store.auth.isLoggedIn,
}))
@observer
class SignUpForm extends React.Component {
  render() {

    return (
      !this.props.isLoggedIn ?
      (
        <InputContainer isMobile={this.props.isMobile}>
          <Text>
            {this.props.accountRequired ? "Create your account" : "Enter Your Payment Info"}
            {' '}
            <Or>or</Or>
            {' '}
            <LoginModal opener={opener} />
          </Text>
          <Spacer mobile={20} desktop={20} />
          <ContinueWithButtons trackCheckoutLogin />
          <Spacer mobile={10} desktop={10} />
          <SignInTable />
        </InputContainer>
      ) : <Spacer mobile={30} desktop={30} />
    )
  }
}

export default SignUpForm
